<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<th></th>
				<th>{{ 'adminstat.common.Status' | translate }}</th>
				<th>{{ 'adminstat.billing.domain_billing.domainName' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let domainName of details; let i = index">
				<td>
					{{ i + 1 }}
				</td>
				
				<td>
					{{ 'adminstat.billing.domain_billing.success' | translate }}
				</td>
				
				<td>
					<a target="_blank" rel="noreferrer" [href]="'http://'  + domainName">{{ domainName }}</a>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
